import { select, all, call, fork, put, takeEvery } from 'redux-saga/effects';
import centralApiAxios from "../../axios/centralApiAxios";
import {
    GET_WEB_BUILDER_DATA,
    HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION,
    SAVE_DESIGNER_DATA
} from '../actions';
import {
    getWebBuilderDataSuccess,
    getWebBuilderDataError,
    handleChangeOnCollectionItemOptionSuccess,
    handleChangeOnCollectionItemOptionError,
    saveDesignerDataSuccess,
    saveDesignerDataError
} from './actions';
import { getActivityHeadersUpdated } from '../../utils/parentChildActivities';
const designerDataError = "Failed to retrieve designer data.";
const saveDesignerDataErrorMsg = "Failed to save designer data.";
export function* watchGetWebBuilderData() {
    yield takeEvery(GET_WEB_BUILDER_DATA, getWebBuilderData);
}
export function* watchSaveDesignerData() {
    yield takeEvery(SAVE_DESIGNER_DATA, saveDesignerData);
}
const getSelectedCollectionItemOptions = (state) => {
    return state.webBuilder && state.webBuilder.selectedCollectionItemOptions ? state.webBuilder.selectedCollectionItemOptions : [];
}
const getAllCollectionItemOptions = (state) => {
    return state.webBuilder && state.webBuilder.allCollectionItemOptions ? state.webBuilder.allCollectionItemOptions : [];
}

const getWebBuilderDataAsync = async (payload) => {

    try {
        const recordCollectionListReturned = await centralApiAxios.get("designer?collectionItemId=" + payload.collectionItemId + "&nodeId=" + (payload.nodeId > 0 ? payload.nodeId : "") + "&isRendering=" + (payload.isRendering ? "true" : "false"), getActivityHeadersUpdated(payload));
        if (recordCollectionListReturned.data) {
            const collectionItemOptionSelected = payload.nodeId > 0 && recordCollectionListReturned.data.collectionItemOptions ? recordCollectionListReturned.data.collectionItemOptions.find(cio => cio.toRecordId === payload.nodeId) : null;
            const webBuilderData = {
                collection: recordCollectionListReturned.data.collection,
                collectionItem: recordCollectionListReturned.data.collectionItem,
                currentNode: recordCollectionListReturned.data.currentNode,
                pageContentItem: recordCollectionListReturned.data.pageContentItem,
                collectionItemOptionCategories: [],
                allCollectionItemOptions: recordCollectionListReturned.data.collectionItemOptions,
                selectedCollectionItemOptions: recordCollectionListReturned.data.collectionItemOptions,
                selectedCollectionItemOption: collectionItemOptionSelected ? collectionItemOptionSelected : null,
                toolboxElements: recordCollectionListReturned.data.toolBoxElements,
                elements: recordCollectionListReturned.data.pageElements,
                masterPageElements: recordCollectionListReturned.data.masterPageElements,
                contents: recordCollectionListReturned.data.contents,
                masterContents: recordCollectionListReturned.data.masterContents
            };
            return {
                webBuilderData: webBuilderData,
                message: null
            }
        }
        return { message: designerDataError };
    } catch (error) {
        return {
            message: designerDataError,
        };
    }
}

function* getWebBuilderData({ payload }) {
    try {
        const dataReturned = yield call(getWebBuilderDataAsync, payload);
        if (!dataReturned.message) {
            yield put(getWebBuilderDataSuccess(dataReturned.webBuilderData));
        } else {
            yield put(getWebBuilderDataError(dataReturned.message));
        }
    } catch (error) {
        yield put(getWebBuilderDataError(error));
    }
}

export function* watchHandleChangeOnCollectionItemOption() {
    yield takeEvery(HANDLE_CHANGE_ON_COLLECTION_ITEM_OPTION, handleChangeOnCollectionItemOption);
}

const handleChangeOnCollectionItemOptionAsync = async (payload, allCollectionItemOptions, selectedCollectionItemOptions) => {
    try {
        let collectionItemOptions = [...selectedCollectionItemOptions];
        let objIndex = selectedCollectionItemOptions.findIndex((obj => obj.nodeEdgeId === payload.collectionItemOption.nodeEdgeId));
        if (objIndex > -1) {
            collectionItemOptions.splice(objIndex, 1); //Delete nodeEdge
        } else {
            let nodeEdge = allCollectionItemOptions.find((obj => obj.nodeEdgeId === payload.collectionItemOption.nodeEdgeId));
            if (nodeEdge) {
                let newNodeEdge = { ...nodeEdge }; //Create new nodeEdge with this collection
                newNodeEdge.parentNodeEdgeId = nodeEdge.nodeEdgeId;
                newNodeEdge.fromNodeId = payload.collectionItemId;
                newNodeEdge.to_RecordType = newNodeEdge.name.indexOf("Form") > -1 ? 10100 : (newNodeEdge.name.indexOf("Email") > -1 ? 20400 : 10505); //set co_CollectionItem_EnumRecordType of the nodeEdge.toRecordId 
                newNodeEdge.toRecordId = Math.floor(Math.random() * 100); //Set created record id of co_CollectionItem_EnumRecordType of the nodeEdge.toRecordId 
                collectionItemOptions.splice(objIndex, 0, newNodeEdge);
            }
        }
        return {
            selectedCollectionItemOptions: collectionItemOptions,
            message: null
        }
    } catch (error) {
        return {
            message: 'Failed to load data.'
        }
    }
}

function* handleChangeOnCollectionItemOption({ payload }) {
    try {
        const selectedCollectionItemOptions = yield select(getSelectedCollectionItemOptions);
        const allCollectionItemOptions = yield select(getAllCollectionItemOptions);
        const dataReturned = yield call(handleChangeOnCollectionItemOptionAsync, payload, allCollectionItemOptions, selectedCollectionItemOptions);
        if (!dataReturned.message) {
            yield put(handleChangeOnCollectionItemOptionSuccess(dataReturned.selectedCollectionItemOptions));
        } else {
            yield put(handleChangeOnCollectionItemOptionError(dataReturned.message));
        }
    } catch (error) {
        yield put(handleChangeOnCollectionItemOptionError(error));
    }
}

const saveDesignerDataAsync = async (payload) => {

    try {
        const webBuilderDataToSave = {
            collectionItem: payload.collectionItem,
            currentNode: payload.currentNode,
            pageElements: payload.elements,
            contents: payload.contents
        };
        const recordCollectionListReturned = await centralApiAxios.post("designer", webBuilderDataToSave);
        if (recordCollectionListReturned.data) {
            const collectionItemOptionSelected = payload.currentNode && payload.currentNode.nodeId > 0 && recordCollectionListReturned.data.collectionItemOptions ? recordCollectionListReturned.data.collectionItemOptions.find(cio => cio.toRecordId === payload.currentNode.nodeId) : null;
            const webBuilderData = {
                collection: recordCollectionListReturned.data.collection,
                collectionItem: recordCollectionListReturned.data.collectionItem,
                currentNode: recordCollectionListReturned.data.currentNode,
                pageContentItem: recordCollectionListReturned.data.pageContentItem,
                collectionItemOptionCategories: [],
                allCollectionItemOptions: recordCollectionListReturned.data.collectionItemOptions,
                selectedCollectionItemOptions: recordCollectionListReturned.data.collectionItemOptions,
                selectedCollectionItemOption: collectionItemOptionSelected ? collectionItemOptionSelected : null,
                toolboxElements: recordCollectionListReturned.data.toolBoxElements,
                elements: recordCollectionListReturned.data.pageElements,
                masterPageElements: recordCollectionListReturned.data.masterPageElements,
                contents: recordCollectionListReturned.data.contents,
                masterContents: recordCollectionListReturned.data.masterContents
            };
            return {
                webBuilderData: webBuilderData,
                message: null
            }
        }
        return { message: saveDesignerDataErrorMsg };
    } catch (error) {
        return {
            message: saveDesignerDataErrorMsg,
        };
    }
}

function* saveDesignerData({ payload }) {
    try {
        const dataReturned = yield call(saveDesignerDataAsync, payload.webBuilderData);
        if (!dataReturned.message) {
            yield put(saveDesignerDataSuccess(dataReturned.webBuilderData));
        } else {
            yield put(saveDesignerDataError(dataReturned.message));
        }
    } catch (error) {
        yield put(saveDesignerDataError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchGetWebBuilderData),
        fork(watchHandleChangeOnCollectionItemOption),
        fork(watchSaveDesignerData)
    ]);
}